var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-button',{attrs:{"type":"primary","disabled":!_vm.row.hasSku,"plain":"","size":"mini"},on:{"click":function($event){return _vm.showSkuDrawer(_vm.row.productId)}}},[_vm._v("选择规格")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }